export default "__VITE_ASSET__B$wb48cl__"